import { Post } from '@/model/post'
import getDate from '@/util/getDate'

import CardMedia from './cardMedia'

const PostCard = ({ data, name, slug, published_date }: Post) => {
  return (
    <article className="px-4 md:w-1/4 w-full pt-4 pb-1">
      <div className="shadow-md">
        <CardMedia
          name={name}
          href={`${process.env.NEXT_PUBLIC_KISAN_APP}/dehaat/post/${slug}`}
          {...data}
        />
        <a
          href={`${process.env.NEXT_PUBLIC_KISAN_APP}/dehaat/post/${slug}`}
          target="_blank"
          rel="noopener noreferrer"
          className="block px-4 py-2.5 h-[84px] overflow-hidden"
        >
          <span className="text-[#6bb51e] text-xs block">
            {getDate(published_date)}
          </span>
          <span className="text-black font-natosans-medium text-[13px] block">
            {name}
          </span>
        </a>
      </div>
    </article>
  )
}

export default PostCard
